import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Bio,
  BoxCards,
  BoxNames,
  CardName,
  Contact,
  Container,
  ContentNames,
  ContentText,
  ImgCemforpe,
  Map,
  Photo,
  Text,
  Title,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { icons, images } from "../../constants";

const AboutUs = () => {
  return (
    <Container>
      
      <Menu />

      <Banner icon={images.iconConheca}>CONHEÇA</Banner>
      <ContentBox>
        <ImgCemforpe src={images.cemforpe} />
        <ContentText>

          <Text>
            O Departamento Pedagógico, vinculado à Secretaria Municipal de Educação, chancela suas pautas de trabalho por meio de políticas públicas focadas 
            em atender às perspectivas de desenvolvimento integral dos alunos da rede. Para tanto, orienta-se pela relação colaborativa entre a construção de 
            materiais didáticos, recursos tecnológicos, formação continuada e avaliação.
          </Text>
        
          <Text>
            Para o alcance de suas metas, organiza-se em diversas equipes, que trabalham de forma integrada e em sintonia com o que preconizam os documentos 
            norteadores, tendo em vista sempre o atendimento aos Direitos dos estudantes em sua integralidade.
          </Text>
        
          <Text>
            Nossas equipes:
          </Text>
        </ContentText>
        <ContentNames>

          <BoxNames>
          <Title>1 - Direção</Title>

              <CardName>
                <Photo src={images.mitch} />
                <Bio><b>Mitch Rodrigo Prado de Almeida</b>
                  Diretor Geral do DEPED
                </Bio>
                
              </CardName>

            <Title>2 - Educação Básica</Title>
            
            {/* <BoxCards> */}
              <CardName>
                <Photo src={images.rosana} />
                <Bio><b>Rosana Maza Grandineti</b>
                Chefe de Divisão da Ed. Básica</Bio>
              </CardName>

            <Title>2.1 - Educação Infantil</Title>

            {/* </BoxCards> */}

            <BoxCards>

              {/* <CardName>
                <Photo src={icons.login} />
                <Bio><b>Ana Clara Camargo de M. e Faria</b>
                Técnico Pedagógico Ed. Infantil</Bio>
              </CardName> */}
                          
              <CardName>
                <Photo src={images.andreia} />
                <Bio><b>Andréa Cristina M. G. Garcia</b>
                Téc. Pedagógico - Ed. Infantil</Bio>
              </CardName>
              
              <CardName>
                <Photo src={images.aniele} />
                <Bio><b>Aniele Armelin Barbosa</b>
                Téc. Pedagógico - Ed. Infantil</Bio>
              </CardName>

              <CardName>
                <Photo src={images.angelica} />
                <Bio><b>Angelica Aparecida Curvelo Alves</b>
                Téc. Pedagógico - Ed. Infantil</Bio>
              </CardName>

              <CardName>
                <Photo src={images.lilian} />
                <Bio><b>Lilian Gadini</b>
                Téc. Pedagógico - Ed. Infantil</Bio>
              </CardName>

              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Ana Clara C. de Moraes e Faria</b>
                Téc. Pedagógico - Ed. Infantil</Bio>
              </CardName>

            </BoxCards>
            
            <Title>2.2 - Ensino Fundamental</Title>
 
            <BoxCards>
                       
              <CardName>
                <Photo src={images.adriana} />
                <Bio><b>Adriana Aparecida da Cunha</b>
                Téc. Pedagógico - Matemática</Bio>
              </CardName>

              <CardName>
                <Photo src={images.gabicerqueira} />
                <Bio><b>Gabriela Lima Cerqueira</b>
                Téc. Pedagógico - Matemática</Bio>
              </CardName>

              <CardName>
                <Photo src={images.wander} />
                <Bio><b>Wanderlei Lopes Primoo</b>
                Téc. Pedagógico - Matemática</Bio>
              </CardName>

              <CardName>
                <Photo src={images.anacarol} />
                <Bio><b>Ana Carolina Faber Boog</b>
                Téc. Pedagógico - Ed. Física</Bio>
              </CardName>

              <CardName>
                <Photo src={images.monicasenziali} />
                <Bio><b>Mônica Senziali S. de Oliveira</b>
                Téc. Pedagógico - Ed. Física</Bio>
              </CardName>

              <CardName>
                <Photo src={images.cintia} />
                <Bio><b>Cíntia Maria A. de Oliveira</b>
                Ciências Naturais / Esc. Ambiental</Bio>
              </CardName>

              <CardName>
                <Photo src={images.diaglo} />
                <Bio><b>Diaglo Pascoalle Melo Ferreira</b>
                Ciências Naturais / Esc. Ambiental</Bio>
              </CardName>

              <CardName>              
                <Photo src={images.luizflavio} />
                <Bio><b>Luiz Flávio Silva</b>
                Ciências Humanas e Sociais / MUVE</Bio>
              </CardName>

              <CardName>
                <Photo src={images.monicafelismino} />
                <Bio><b>Mônica Raquel de S. M. Felismino</b>
                Ciências Humanas e Sociais / MUVE</Bio>
              </CardName>

              <CardName>
                <Photo src={images.carolina} />
                <Bio><b>Carolina Domingues</b>
                Téc. Pedagógico - Líng. Portuguesa</Bio>
              </CardName>

              <CardName>
                <Photo src={images.lucianacampos} />
                <Bio><b>Luciana Campos B. Sant'anna</b>
                Téc. Pedagógico - Líng. Portuguesa</Bio>
              </CardName>

              <CardName>
                <Photo src={images.anamaria} />
                <Bio><b>Ana Maria Tertuliano Americo</b>
                Téc. Pedagógico - Sanção Premial</Bio>
              </CardName>

              <CardName>
                <Photo src={images.neto} />
                <Bio><b>Geraldo Monteiro Neto</b>
                Téc. Pedagógico - Artes</Bio>
              </CardName>

              <CardName>
                <Photo src={images.joelma} />
                <Bio><b>Joelma da Silveira</b>
                Téc. Pedagógico - Tecnologia Ed.</Bio>
              </CardName>

              <CardName>
                <Photo src={images.patricia} />
                <Bio><b>Patrícia Francisca da Silva</b>
                Téc. Pedagógico - Tecnologia Ed.</Bio>
              </CardName>


            </BoxCards>


            <Title>3 - Equipe de Avaliação</Title>
 
            <BoxCards>

              <CardName>
                <Photo src={images.marcatti} />
                <Bio><b>Maria Cristina Marcatti</b>
                Téc. Pedagógico - Avaliação</Bio>
              </CardName>
                          
              <CardName>
                <Photo src={images.nayara} />
                <Bio><b>Nayara Xavier de Souza</b>
                Téc. Pedagógico - Avaliação</Bio>
              </CardName>
{/* 
              <CardName>
                <Photo src={images.suellen} />
                <Bio><b>Sue Ellen Souza de O. Camargos</b>
                Téc. Ped. - Avaliação / Alfabetização</Bio>
              </CardName> */}

            </BoxCards>

            <Title>4 - Tecnologia e Inovação Pedagógica</Title>
            
            <BoxCards>

              <CardName>
                <Photo src={images.alexandre} />
                <Bio><b>Alexandre Roberto Rodrigues</b>
                OI - Diagramação</Bio>
              </CardName>

              <CardName>
                <Photo src={images.andre} />
                <Bio><b>André Kimwa Chan</b>
                OI - Diagramação</Bio>
              </CardName>

              <CardName>
                <Photo src={images.gustavo} />
                <Bio><b>Luiz Gustavo Firveda de Almeida</b>
                OI - Diagramação / Sistemas</Bio>
              </CardName>

              <CardName>
                <Photo src={images.angelo} />
                <Bio><b>Angelo Nunes Camargo</b>
                OI - Sistemas</Bio>
              </CardName>

              <CardName>
                <Photo src={images.edgar} />
                <Bio><b>Edgar Yoshida Salomão</b>
                OI - Sistemas</Bio>
              </CardName>

              <CardName>
                <Photo src={images.carloskomoto} />
                <Bio><b>Carlos Yukio Komoto</b>
                &nbsp; OI - Sistemas</Bio>
              </CardName>

              <CardName>
                <Photo src={images.lucianaleite} />
                <Bio><b>Luciana Paula Leite de Oliveira</b>
                OI - Sistemas</Bio>
              </CardName>
{/* 
              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Márcia Kabakura</b></Bio>
              </CardName> */}

              <CardName>
                <Photo src={images.valeria} />
                <Bio><b>Valéria Cristina Kato</b>
                OI - Análise de dados</Bio>
              </CardName>

              <CardName>
                <Photo src={images.fabricio} />
                <Bio><b>Fabrício Machado da Rocha</b>
                OI - Audiovisual</Bio>
              </CardName>

              <CardName>
                <Photo src={images.jefferson} />
                <Bio><b>Jefferson Petreski</b>
                &nbsp; OI - Audiovisual</Bio>
              </CardName>

              <CardName>
                <Photo src={images.henrique} />
                <Bio><b>Luiz Henrique da Motta Santos</b>
                OI - Audiovisual</Bio>
              </CardName>
                        
            </BoxCards>

            <Title>5 - Biblioteca</Title>
            
            <BoxCards>

            <CardName>
                <Photo src={images.osmar} />
                <Bio><b>Osmar Alves da Silva</b>
                &nbsp; Bibliotecário</Bio>
              </CardName>
                        
            </BoxCards>

            <Title>6 - Equipe Administrativa</Title>

            <BoxCards>

              <CardName>
                <Photo src={images.adilson} />
                <Bio><b>Adilson Campos da Silva</b>
                Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={images.gabisalla} />
                <Bio><b>Gabriella Regina Sala Martinelli</b>
                Apoio Administrativo</Bio>
              </CardName>
              
              <CardName>
                <Photo src={images.gisele} />
                <Bio><b>Gisele Aparecida Ribeiro de Faria</b>
                Apoio Administrativo</Bio>
              </CardName>
                        
              <CardName>
                <Photo src={images.jose} />
                <Bio><b>José Vitor Mesquita</b>
                Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={images.rieko} />
                <Bio><b>Rieko Kasuya</b>
                &nbsp; Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={images.eny} />
                <Bio><b>Eny Massae Sato</b>
                Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Noemia Gino dos Santos Ferreira</b>
                Apoio Administrativo</Bio>
              </CardName>
                        
            </BoxCards>

            <Title>7 - Equipe Auditório</Title>

            <BoxCards>

              <CardName>
                <Photo src={images.soraya} />
                <Bio><b>Soraya Dilger Fernandes</b>
                Chefe de divisão</Bio>
              </CardName>

              <CardName>
                <Photo src={images.carlos} />
                <Bio><b>Carlos Antônio Filho</b>
                Apoio Administrativo</Bio>
              </CardName>
                          
              <CardName>
                <Photo src={images.rafael} />
                <Bio><b>Rafael Neves Bonilha</b>
                Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={images.flavio} />
                <Bio><b>Flávio Lima Cipresso</b>
                Apoio Administrativo</Bio>
              </CardName>

              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Enéas Rosa Januário</b>
                Apoio Administrativo</Bio>
              </CardName>

            </BoxCards>
   
            <Title>8 - Equipes Externas</Title>

            <BoxCards>

              <CardName>
                <Photo src={images.elaine} />
                <Bio><b>Elaine Jussara Tolosa</b>
                Equipe MUVE</Bio>
              </CardName>

              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Miria Carrasco Duran</b>
                Equipe MUVE</Bio>
              </CardName>
{/* 
              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Rodrigo A. Brunaikovics da Silva</b>
                Equipe MUVE</Bio>
              </CardName>
                         */}
              <CardName>
                <Photo src={images.valter} />
                <Bio><b>Valter Roberto Machado Giner
                </b>Escola Ambiental</Bio>
              </CardName>
             
              <CardName>
                <Photo src={images.gilberto} />
                <Bio><b>Gilberto Henrique da Silva Junior</b>UNIVESP</Bio>
              </CardName>

              <CardName>
                <Photo src={images.paulo} />
                <Bio><b>Paulo Roberto de Oliveira</b>UNIVESP</Bio>
              </CardName>

              <CardName>
                <Photo src={images.roberto} />
                <Bio><b>Roberto Scarcelli P. T. Costa</b>UNIVESP</Bio>
              </CardName>
                        
            </BoxCards>

         <Title>9 - Programas Musicais</Title>

            <BoxCards>

              <CardName>
                <Photo src={images.leandro} />
                <Bio><b>Leandro Michel Tomazzini</b>
                Projetos Especiais da Educação</Bio>
              </CardName>
 
            </BoxCards>

            <Title>10 - Equipe Demax</Title>

            <BoxCards>

              <CardName>
                <Photo src={images.dirce} />
                <Bio><b>Dirce Aparecida dos Santos</b>
                DEMAX - Equipe CEMFORPE</Bio>
              </CardName>

              <CardName>
                <Photo src={images.kariny} />
                <Bio><b>Kariny Rodrigues A. de Andrade</b>
                DEMAX - Equipe CEMFORPE</Bio>
              </CardName>

              <CardName>
                <Photo src={icons.login} />
                <Bio><b>Gabriela Oliveira Rosa</b>
                DEMAX - Equipe CEMFORPE</Bio>
              </CardName>
              
              <CardName>
                <Photo src={images.beatriz} />
                <Bio><b>Beatriz Raissa da Silva</b>
                &nbsp;DEMAX - Equipe Auditório</Bio>
              </CardName>
              
              <CardName>
                <Photo src={images.pamela} />
                <Bio><b>Pambela Eduarda</b>
                &nbsp; DEMAX - Equipe Auditório</Bio>
              </CardName>

              <CardName>
                <Photo src={images.elisabete} />
                <Bio><b>Elisabete</b>
                &nbsp; DEMAX - Equipe Auditório
                </Bio>
              </CardName>

              <CardName>
                <Photo src={images.vanessa} />
                <Bio><b>Vanessa Pereira dos Santos</b>
                &nbsp;DEMAX - Equipe Auditório</Bio>
              </CardName>

              <CardName>
                <Photo src={images.elivandra} />
                <Bio><b>Elivanda Aparecida Diniz Ferreira</b>
                DEMAX - Escola Ambiental</Bio>
              </CardName>
              
               <CardName>
                <Photo src={icons.login} />
                <Bio><b>Rochelle Armond da Silva Braga</b>
                &nbsp; DEMAX - Equipe MUVE</Bio>
              </CardName>

            </BoxCards>

          </BoxNames>
        </ContentNames>
        <ContentText>
          <Text>
            O Departamento Pedagógico tem sua sede no CEMFORPE (Centro Municipal de Formação Pedagógica), localizado no bairro Nova Mogilar em Mogi das Cruzes.
            Há outros dois espaços que também fazem parte do departamento, que é o MUVE e a Escola Ambiental.
          </Text>
         
        </ContentText>
        <Map
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.6427879309726!2d-46.18705018449484!3d-23.509372565560813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cdd826b0f6a54d%3A0x193a3e29dd57e3f8!2sCEMFORPE!5e0!3m2!1spt-BR!2sbr!4v1653050822515!5m2!1spt-BR!2sbr"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        />
        <Contact>Rua Antenor Leite da Cunha, 55 - Nova Mogilar</Contact>
        <Contact>CEP: 08773-395, Mogi das Cruzes - SP.</Contact>
        <Contact>Segunda a sexta-feira, das 8 às 17 horas.</Contact>
        <Contact>(11) 4791-3520</Contact>
        <Contact>deped@sme-mogidascruzes.sp.gov.br</Contact>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default AboutUs;